/**
 * Katalog sirasi: all / all-items sayfalarinda tek seferlik client sort.
 * Infinite scroll kapali oldugundan MutationObserver kullanilmaz (scroll titremesi/onlenir).
 */
function compareSortItems(a, b) {
  const taraftarDiff = Number(b.dataset.taraftar || 0) - Number(a.dataset.taraftar || 0);
  if (taraftarDiff !== 0) return taraftarDiff;
  const sortDiff = Number(b.dataset.catalogSort || 0) - Number(a.dataset.catalogSort || 0);
  if (sortDiff !== 0) return sortDiff;
  return Number(b.dataset.reviewCount || 0) - Number(a.dataset.reviewCount || 0);
}

function sortCollectionGrid(root) {
  const grid = root.querySelector('[ref="grid"], .product-grid');
  if (!grid || grid.dataset.reviewSortDone === 'true') return false;

  const items = [...grid.querySelectorAll('.product-grid__item[data-catalog-sort]')];
  if (items.length < 2) return false;

  const seen = new Set();
  const unique = [];

  for (const item of items) {
    const id = item.dataset.productId;
    if (!id || seen.has(id)) {
      // DOM'dan silme — ürün kaybolmasın; sadece sıraya alma.
      item.hidden = true;
      continue;
    }
    seen.add(id);
    item.hidden = false;
    unique.push(item);
  }

  unique.sort(compareSortItems);

  const orderChanged = unique.some((item, index) => grid.children[index] !== item);
  if (!orderChanged) {
    grid.dataset.reviewSortDone = 'true';
    return false;
  }

  unique.forEach((item) => grid.appendChild(item));
  grid.dataset.reviewSortDone = 'true';
  return true;
}

function initCollectionReviewSort() {
  document.querySelectorAll('results-list[data-catalog-sort-enabled="true"]').forEach((list) => {
    sortCollectionGrid(list);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCollectionReviewSort, { once: true });
} else {
  initCollectionReviewSort();
}

document.addEventListener('shopify:section:load', initCollectionReviewSort);
